/**
 * Los encabezados de la PLANILLA DE CARGA, en un solo lugar.
 *
 * Es el contrato del ida y vuelta: se baja la planilla, BET la completa y la vuelve a subir.
 * El exportador escribe estas columnas y el importador las busca por estos mismos nombres, así
 * que viven acá y no repetidos en cada punta — si se renombra una y la otra no se entera, el
 * archivo deja de reconocerse y el usuario ve "no encontré ninguna columna" sin saber por qué.
 *
 * ⚠️ Sólo CUATRO columnas se aplican al subir. El resto viaja como referencia —para que quien
 * completa sepa de qué producto habla— y **se ignora**: stock, venta y demanda las escribe la
 * ingesta desde el B2B, y dejar que una planilla las pise sería reemplazar el dato real por
 * una foto vieja.
 */

/** Las que el importador SÍ aplica. */
export const COLUMNAS_EDITABLES = {
  costo: 'Costo unitario',
  leadTime: 'Tiempo de produccion (dias)',
  moq: 'MOQ',
  proveedor: 'Proveedor',
  // Los dos de la migración 011. Van acá porque cargarlos para 300 productos a mano no lo
  // hace nadie, que es el mismo motivo por el que existe la planilla.
  //
  // ⚠️ Y tienen una limitación que las instrucciones dicen: desde la planilla se puede FIJAR
  // un valor, pero NO volver a automático — porque en este archivo una celda vacía significa
  // "no lo toques", y esa regla no se toca (es la que evita que media planilla completada
  // ponga en cero el catálogo). Para volver a automático se vacía la celda en la pantalla.
  colchonPct: 'Colchon (% de la espera)',
  reorden: 'Punto de reorden (uds)',
} as const;

/** Las de referencia: se escriben al bajar, se ignoran al subir. */
export const COLUMNAS_REFERENCIA = {
  sku: 'SKU',
  nombre: 'Producto',
  categoria: 'Categoria',
  marca: 'Marca',
  stock: 'Stock actual',
  demanda: 'Demanda por dia',
  cobertura: 'Cobertura (dias)',
  estado: 'Estado',
} as const;

/** La única obligatoria: sin ella no se sabe a qué producto corresponde la fila. */
export const COLUMNA_CLAVE = COLUMNAS_REFERENCIA.sku;

/**
 * Los encabezados van SIN TILDES a propósito.
 *
 * No es descuido: el archivo lo abre y lo guarda gente con Excel en distintas configuraciones,
 * y una "ó" puede volver de un guardado en otra codificación como "Ã³" — con lo cual el
 * importador ya no reconoce la columna y el usuario ve un error que no puede explicar. El
 * texto de la pantalla sí lleva tildes; los encabezados que viajan en el archivo, no.
 */
export const TODAS = { ...COLUMNAS_REFERENCIA, ...COLUMNAS_EDITABLES };

/** Normaliza un encabezado para compararlo: sin tildes, sin espacios de más, en minúsculas. */
export function normalizar(encabezado: string): string {
  return encabezado
    .normalize('NFD')
    .replace(/[^\x20-\x7E]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}
